// extracted by mini-css-extract-plugin
export default {"container":"Oj1aTq mz-price-breakdown__item Pgrqvw","label":"Q0QAOZ"};